import { useState, useEffect } from 'react';

const newsItems = [
  {
    id: 1,
    title: "Lanzamiento de la Nueva Línea de Sensores Inteligentes",
    date: "15 de Julio, 2024",
    image: "/news-sensors.jpg",
    summary: "Presentamos nuestra innovadora gama de sensores inteligentes con tecnología de punta para una mayor precisión y eficiencia en la automatización industrial. ¡Descubre cómo pueden transformar tus operaciones!",
    fullContent: "En R&M Componentes Industriales, estamos emocionados de anunciar el lanzamiento de nuestra nueva línea de sensores inteligentes. Estos dispositivos de última generación incorporan tecnología avanzada para ofrecer una precisión sin precedentes y una mayor eficiencia en la recolección de datos. Diseñados para entornos industriales exigentes, nuestros sensores inteligentes son ideales para aplicaciones de monitoreo, control de calidad y optimización de procesos. Su conectividad mejorada y su interfaz intuitiva facilitan la integración en sistemas existentes, permitiendo a nuestros clientes tomar decisiones más informadas y mejorar significativamente su productividad. ¡Contáctanos para una demostración!"
  },
  {
    id: 2,
    title: "Participación en la Expo Industrial 2024",
    date: "10 de Junio, 2024",
    image: "/news-expo.jpg",
    summary: "Fuimos parte de la Expo Industrial 2024, presentando nuestras últimas soluciones en automatización y estableciendo nuevas conexiones estratégicas. ¡Gracias a todos los que nos visitaron!",
    fullContent: "R&M Componentes Industriales tuvo una destacada participación en la reciente Expo Industrial 2024, uno de los eventos más importantes del sector. Durante la feria, nuestro equipo tuvo la oportunidad de presentar nuestras soluciones más innovadoras en neumática, automatización y materiales eléctricos a una audiencia global. Establecimos valiosas conexiones con profesionales de la industria, exploramos nuevas tendencias tecnológicas y reforzamos nuestro compromiso con el avance del sector. Agradecemos a todos los visitantes que se acercaron a nuestro stand y mostraron interés en nuestras propuestas. ¡Esperamos verlos en la próxima edición!"
  },
  {
    id: 3,
    title: "Webinar Gratuito: Optimización de Procesos con Perfiles de Aluminio",
    date: "20 de Mayo, 2024",
    image: "/news-webinar.jpg",
    summary: "Únete a nuestro próximo webinar gratuito donde exploraremos cómo los perfiles de aluminio pueden revolucionar tus estructuras industriales y mejorar la eficiencia operativa. ¡Regístrate ahora!",
    fullContent: "Te invitamos a participar en nuestro exclusivo webinar gratuito: 'Optimización de Procesos con Perfiles de Aluminio'. En esta sesión, nuestros expertos compartirán conocimientos clave sobre cómo la versatilidad y resistencia de los perfiles de aluminio pueden ser aprovechadas para diseñar estructuras industriales más eficientes, seguras y adaptables. Aprenderás sobre las últimas tendencias en diseño modular, casos de éxito y consejos prácticos para implementar estas soluciones en tu empresa. ¡No pierdas la oportunidad de mejorar tus operaciones! Regístrate a través de nuestro sitio web."
  },
  {
    id: 4,
    title: "Nueva Alianza Estratégica con Fabricante Líder de Teflones",
    date: "01 de Mayo, 2024",
    image: "/news-alliance.jpg",
    summary: "Anunciamos una nueva alianza estratégica que nos permitirá ofrecer una gama aún más amplia de productos de teflón de alta calidad para aplicaciones industriales especializadas.",
    fullContent: "En un esfuerzo continuo por expandir nuestro portafolio y ofrecer las mejores soluciones a nuestros clientes, R&M Componentes Industriales se enorgullece de anunciar una nueva alianza estratégica con un fabricante líder mundial de productos de teflón. Esta colaboración nos permitirá acceder a tecnologías de fabricación avanzadas y a una gama más diversa de materiales de PTFE y polímeros de alto rendimiento. Con esta alianza, reforzamos nuestra capacidad para satisfacer las demandas más exigentes de la industria, proporcionando productos de teflón con propiedades superiores de resistencia química, térmica y mecánica."
  },
  {
    id: 3,
    title: "Webinar Gratuito: Optimización de Procesos con Perfiles de Aluminio",
    date: "20 de Mayo, 2024",
    image: "/news-webinar.jpg",
    summary: "Únete a nuestro próximo webinar gratuito donde exploraremos cómo los perfiles de aluminio pueden revolucionar tus estructuras industriales y mejorar la eficiencia operativa. ¡Regístrate ahora!",
    fullContent: "Te invitamos a participar en nuestro exclusivo webinar gratuito: 'Optimización de Procesos con Perfiles de Aluminio'. En esta sesión, nuestros expertos compartirán conocimientos clave sobre cómo la versatilidad y resistencia de los perfiles de aluminio pueden ser aprovechadas para diseñar estructuras industriales más eficientes, seguras y adaptables. Aprenderás sobre las últimas tendencias en diseño modular, casos de éxito y consejos prácticos para implementar estas soluciones en tu empresa. ¡No pierdas la oportunidad de mejorar tus operaciones! Regístrate a través de nuestro sitio web."
  },
  {
    id: 4,
    title: "Nueva Alianza Estratégica con Fabricante Líder de Teflones",
    date: "01 de Mayo, 2024",
    image: "/news-alliance.jpg",
    summary: "Anunciamos una nueva alianza estratégica que nos permitirá ofrecer una gama aún más amplia de productos de teflón de alta calidad para aplicaciones industriales especializadas.",
    fullContent: "En un esfuerzo continuo por expandir nuestro portafolio y ofrecer las mejores soluciones a nuestros clientes, R&M Componentes Industriales se enorgullece de anunciar una nueva alianza estratégica con un fabricante líder mundial de productos de teflón. Esta colaboración nos permitirá acceder a tecnologías de fabricación avanzadas y a una gama más diversa de materiales de PTFE y polímeros de alto rendimiento. Con esta alianza, reforzamos nuestra capacidad para satisfacer las demandas más exigentes de la industria, proporcionando productos de teflón con propiedades superiores de resistencia química, térmica y mecánica."
  }
];

const NewsPage = () => {
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.75) {
          element.classList.add('opacity-100', 'translate-y-0', 'scale-100');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleReadMore = (newsItem) => {
    setSelectedNews(newsItem);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top to show full content
  };

  const handleBackToList = () => {
    setSelectedNews(null);
  };

  return (
    <div className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-5xl font-bold text-center text-gray-900 mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          Nuestras <span className="text-red-600">Novedades</span>
        </h1>

        {selectedNews ? (
          // Vista de contenido completo de la noticia
          <div className="bg-white p-10 rounded-xl shadow-xl animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
            <button 
              onClick={handleBackToList} 
              className="mb-8 text-red-600 hover:text-red-800 font-semibold flex items-center transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
              Volver a Novedades
            </button>
            <img src={selectedNews.image} alt={selectedNews.title} className="w-full h-96 object-cover rounded-lg mb-8 shadow-md" />
            <h2 className="text-4xl font-bold text-gray-900 mb-4">{selectedNews.title}</h2>
            <p className="text-gray-500 text-sm mb-6">{selectedNews.date}</p>
            <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-line">{selectedNews.fullContent}</p>
          </div>
        ) : (
          // Vista de lista de noticias
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {newsItems.map((news, index) => (
              <div 
                key={news.id} 
                className={`bg-white p-8 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-500 delay-${index * 100} animate-on-scroll opacity-0 translate-y-10`}
              >
                <img src={news.image} alt={news.title} className="w-full h-48 object-cover rounded-lg mb-6 shadow-sm" />
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{news.title}</h3>
                <p className="text-gray-500 text-sm mb-4">{news.date}</p>
                <p className="text-gray-700 leading-relaxed mb-6">{news.summary}</p>
                <button 
                  onClick={() => handleReadMore(news)} 
                  className="text-red-600 hover:text-red-800 font-medium flex items-center group transition-colors"
                >
                  Leer más 
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default NewsPage;